import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ServiceLinesQueryCgResponse,
  ServiceLinesQueryVariables,
} from '@common/graphql';

export const SERVICE_LINES_QUERY: TypedDocumentNode<
  ServiceLinesQueryCgResponse,
  ServiceLinesQueryVariables
> = gql`
  query ServiceLines {
    serviceLines {
      id
      name
    }
  }
`;
